"use client"

import Carousel from "@/components/common/Carousel"
import NextImage from "@/components/common/NextImage"
import { useDevicePassedWidth } from "@/hooks/app/useDevicePassedWidth"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Col } from "antd"
import { Fragment, useEffect, useState } from "react"

const Banner = ({ metaData }: { metaData: any }) => {
  const isDesktop = useIsDesktop()
  const passedWidth = useDevicePassedWidth(w => w > 1600)

  const [isLargeBanner, setIsLargeBanner] = useState<any>(-1)

  useEffect(() => {
    if (isLargeBanner !== -1) return;
    setIsLargeBanner(passedWidth)
  }, [passedWidth, isLargeBanner])

  if (metaData.enabled_banner_carousel && !!metaData?.carousel_banner_data?.length) {
    return (
      <Col span={24}>
        <Carousel
          options={{
            lazyLoad: 1,
            wrapAround: true,
            prevNextButtons: false,
            adaptiveHeight: true,
            draggable: true,
            // setGallerySize: false,

            autoPlay: !!metaData?.enabled_carousel_banner_auto_play
              ? parseFloat(`${metaData?.duration_carousel_banner_auto_play || '5000'}`)
              : undefined
          }}
        >
          {(metaData as any).carousel_banner_data?.map(({ url, uid }: any, idx: any) => (
            <NextImage
              key={idx}
              hiddenSpin
              style={{ width: '100%', height: "auto", objectFit: "cover" }}
              width={2000}
              height={2000}
              src={url as any}
              fetchPriority='high'
              alt={`Banner carousel image ${idx + 1}`}
            />
          ))}
        </Carousel>
      </Col>
    )
  }

  const validBanner = !!(metaData.banner?.disabled ? '' : metaData.banner?.url)
  const validBanner192x1080 = !!(metaData.banner_1920x1080?.disabled ? '' : metaData.banner_1920x1080?.url)
  const validBannerMobile = !!(metaData.banner_mobile?.disabled ? '' : metaData.banner_mobile?.url)

  const banner = validBanner
    ? metaData.banner
    : validBanner192x1080
      ? metaData.banner_1920x1080
      : metaData.banner_mobile

  const banner1920x1080 = validBanner192x1080
    ? metaData.banner_1920x1080
    : validBanner
      ? metaData.banner
      : metaData.banner_mobile

  const bannerMobile = validBannerMobile
    ? metaData.banner_mobile
    : validBanner
      ? metaData.banner
      : metaData.banner_1920x1080

  const staticBannerData = [
    {
      banner: banner,
      className: "home__banner",
    },
    {
      banner: bannerMobile,
      className: "home__banner--mobile"
    },
    {
      banner: banner1920x1080,
      className: "home__banner--1920x1080"
    }
  ]

  const validBanners = staticBannerData.filter(({ banner, className }) => {
    if (isLargeBanner !== -1) {
      if (isDesktop) {
        if (className === 'home__banner--mobile') {
          return false
        }
        if (isLargeBanner === true) {
          if (className === 'home__banner--mobile' || className === 'home__banner') {
            return false
          }
        } else if (className === 'home__banner--1920x1080') {
          return false
        }
      } else if (className === 'home__banner--1920x1080' || className === 'home__banner') {
        return false
      }
    }
    return !!banner?.url
  })

  if (!validBanners.length) {
    return <Fragment />
  }

  return (
    <Col span={24} style={isLargeBanner !== -1 ? {} : { opacity: 0, visibility: 'hidden' }}>
      {validBanners.map(({ banner, className }, idx) => {
        if (!!banner?.ext && !banner?.ext?.includes("image")) {
          return (
            <video
              key={idx}
              className={className}
              autoPlay
              muted
              loop
              style={{
                objectFit: 'cover',
                width: '100%'
              }}
              src={banner?.url}
            />
          )
        }
        return (
          <NextImage
            key={idx}
            style={{ width: '100%', height: "auto", maxHeight: `${((banner?.height || 2000) / (banner?.width || 2000) * 100)}vw`, objectFit: "cover" }}
            width={banner?.width || 2000}
            height={banner?.height || 2000}
            sizes='100vw'
            src={banner?.url as any}
            alt={`Banner image`}
            className={className}
            fetchPriority='high'
          />
        )
      })}
    </Col>
  )
}

export default Banner